import React, { useEffect, useState } from "react";
import "../CSS/exitIntentPopup.css";
import Cookies from "js-cookie";
import axios from "axios";

const ExitIntentPopup = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [hasScrolledDown, setHasScrolledDown] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [showOtpSection, setShowOtpSection] = useState(false);
  const [showOtpField, setShowOtpField] = useState(false);
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [resendTimer, setResendTimer] = useState(45);
  const [otpVerified, setOtpVerified] = useState(false);
  const [showSuccessText, setShowSuccessText] = useState(false);

  useEffect(() => {
    const handleMouseOut = (e) => {
      if (
        e.clientY <= 0 &&
        !e.toElement &&
        !e.relatedTarget &&
        !Cookies.get("exitIntentShown")
      ) {
        setShowPopup(true);
        Cookies.set("exitIntentShown", "true", { expires: 1 });
      }
    };

    const handleScroll = () => {
      const scrollY = window.scrollY;
      if (scrollY > window.innerHeight) {
        setHasScrolledDown(true);
      }
      if (hasScrolledDown && scrollY < 100 && !Cookies.get("exitIntentShown")) {
        setShowPopup(true);
        Cookies.set("exitIntentShown", "true", { expires: 1 });
      }
    };

    let idleTimeout;
    const resetIdleTimer = () => {
      clearTimeout(idleTimeout);
      if (window.scrollY < window.innerHeight) return;
      idleTimeout = setTimeout(() => {
        if (!Cookies.get("exitIntentShown")) {
          setShowPopup(true);
          Cookies.set("exitIntentShown", "true", { expires: 1 });
        }
      }, 15000);
    };

    document.addEventListener("mouseout", handleMouseOut);
    window.addEventListener("scroll", handleScroll);
    ["scroll", "touchstart", "keydown"].forEach((evt) =>
      document.addEventListener(evt, resetIdleTimer)
    );
    resetIdleTimer();

    return () => {
      document.removeEventListener("mouseout", handleMouseOut);
      window.removeEventListener("scroll", handleScroll);
      ["scroll", "touchstart", "keydown"].forEach((evt) =>
        document.removeEventListener(evt, resetIdleTimer)
      );
    };
  }, [hasScrolledDown]);

  const closePopup = () => {
    setShowPopup(false);
  };

  const handleOtpChange = (e, index) => {
    const value = e.target.value.replace(/\D/g, "");
    if (value.length > 1) return;
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    if (value && index < 3) {
      document.getElementById(`otp-${index + 1}`).focus();
    }
  };

  const resendOtp = async () => {
    setResendTimer(45);
    setOtp(["", "", "", ""]);
    const { data } = await axios.post("/api/form/sms-otp", {
      phoneNumber,
    });
  };

  const verifyOtp = async () => {
    if (otp.join("").length === 4) {
      const newOtp = otp.join("");
      const { data } = await axios.patch("/api/form/sms-otp", {
        phoneNumber,
        otp: newOtp,
      });
      if (data) {
        setOtpVerified(true);
        setShowSuccessText(true);
      }
    } else {
      alert("Please enter 4-digit OTP");
    }
  };

  const submitLead = async (e) => {
    e.preventDefault();
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        "/api/form/exit-intent-popup",
        { phoneNumber, usecase: "voucher helmet" },
        config
      );
      if (data) {
        setShowOtpField(true);
        setResendTimer(45);
      }
    } catch (error) {
      console.error("Something Went Wrong");
    }
  };

  useEffect(() => {
    let timer;
    if (showOtpField && resendTimer > 0) {
      timer = setTimeout(() => setResendTimer((prev) => prev - 1), 1000);
    }
    return () => clearTimeout(timer);
  }, [showOtpField, resendTimer]);

  return (
    <>
      {showPopup && (
        <>
          <div
            className="modal fade d-block show custom-popup-modal"
            tabIndex="-1"
            role="dialog"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content rounded-0">
                <div className="modal-body position-relative p-0">
                  <img
                    src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/Parent+Child/Exit+intent+pop+up.jpg"
                    className="img-fluid rounded-0"
                  />
                  <div
                    className="position-absolute"
                    style={{ top: "2%", right: "2%" }}
                  >
                    <button
                      type="button"
                      className="btn-close"
                      onClick={closePopup}
                    ></button>
                  </div>
                  <div className="position-absolute w-100 exit-intent-form-placement">
                    <div className="d-flex justify-content-center">
                      {showSuccessText ? (
                        <p className="metropolis-medium w-75 text-center text-em">
                          Thanks we have received your details. Our team will
                          get back to you shortly.
                        </p>
                      ) : !showOtpField ? (
                        <>
                          <form onSubmit={submitLead}>
                            <label
                              className="text-center w-100 mb-2 text-uppercase metropolis-medium"
                              style={{ fontSize: "0.9em" }}
                            >
                              Enter Phone Number
                            </label>
                            <input
                              type="tel"
                              value={phoneNumber}
                              onChange={(e) => {
                                const phoneNumber = e.target.value.slice(0, 12);
                                setPhoneNumber(phoneNumber);

                                if (/^[6-9]\d{9}$/.test(phoneNumber)) {
                                  e.target.setCustomValidity("");
                                } else {
                                  e.target.setCustomValidity(
                                    "Enter a valid phone number (10 digits, starting with 6, 7, 8, or 9)"
                                  );
                                }
                              }}
                              onInvalid={(e) =>
                                e.target.setCustomValidity(
                                  "Enter a valid phone number (10 digits, starting with 6, 7, 8, or 9)"
                                )
                              }
                              className="form-control text-center mb-2"
                              style={{
                                width: "300px",
                                background: "transparent",
                                border: "1px solid black",
                              }}
                              required
                            />
                            <button
                              type="submit"
                              style={{ fontSize: "0.8em" }}
                              className="em-btn rounded-2 w-100 py-1 border-none mb-2"
                            >
                              Send OTP
                            </button>
                          </form>
                        </>
                      ) : (
                        <>
                          <div className="mb-2 text-center">
                            <label
                              className="metropolis mb-2"
                              style={{ fontSize: "0.76em" }}
                            >
                              Enter OTP sent to {phoneNumber}
                            </label>
                            <div className="d-flex justify-content-center gap-2">
                              {otp.map((digit, idx) => (
                                <input
                                  key={idx}
                                  type="text"
                                  maxLength="1"
                                  value={digit}
                                  onChange={(e) => {
                                    const val = e.target.value.replace(
                                      /\D/,
                                      ""
                                    );
                                    const newOtp = [...otp];
                                    newOtp[idx] = val;
                                    setOtp(newOtp);
                                    if (val && idx < 3) {
                                      document
                                        .getElementById(`otp-${idx + 1}`)
                                        .focus();
                                    }
                                  }}
                                  id={`otp-${idx}`}
                                  className="form-control text-center"
                                  style={{
                                    width: "40px",
                                    background: "transparent",
                                    border: "1px solid black",
                                    fontSize: "20px",
                                  }}
                                />
                              ))}
                            </div>
                            <div className="d-flex justify-content-center gap-2 mt-3">
                              <button
                                className="btn btn-outline-secondary py-1 px-3"
                                style={{ fontSize: "0.8em" }}
                                onClick={() => {
                                  setShowOtpField(false);
                                  setOtp(["", "", "", ""]);
                                }}
                              >
                                Back
                              </button>
                              <button
                                className="btn btn-primary rounded-2  py-1 border-none py-1 px-3"
                                style={{ fontSize: "0.8em" }}
                                onClick={verifyOtp}
                              >
                                Verify OTP
                              </button>
                            </div>
                            <div className="text-center mt-2">
                              {resendTimer > 0 ? (
                                <span
                                  className="text-muted"
                                  style={{ fontSize: "0.8em" }}
                                >
                                  Resend OTP in {resendTimer}s
                                </span>
                              ) : (
                                <button
                                  className="btn p-0 text-em"
                                  style={{ fontSize: "0.8em" }}
                                  onClick={resendOtp}
                                >
                                  Resend OTP
                                </button>
                              )}
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                    {!showOtpField && (
                      <div
                        className="text-center mb-2"
                        style={{ fontSize: "0.8em" }}
                      >
                        <small className="text-muted text-center">
                          *Only valid on purchase with an e-cycle
                        </small>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="modal-backdrop show"
            style={{ zIndex: 1040, backgroundColor: "rgba(0, 0, 0, 1)" }}
          ></div>
        </>
      )}
    </>
  );
};

export default ExitIntentPopup;
